import(/* webpackMode: "eager", webpackExports: ["PublicRestaurantPageContent"] */ "/vercel/path0/apps/web/components/restaurant/PublicRestaurantPageContent.tsx");
